import { render, staticRenderFns } from "./ForeignStorePanel.vue?vue&type=template&id=0bad3e6b&scoped=true&lang=pug&"
import script from "./ForeignStorePanel.vue?vue&type=script&lang=js&"
export * from "./ForeignStorePanel.vue?vue&type=script&lang=js&"
import style0 from "./ForeignStorePanel.vue?vue&type=style&index=0&id=0bad3e6b&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bad3e6b",
  null
  
)

/* custom blocks */
import block0 from "./ForeignStorePanel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports